import * as React from 'react';
import "./ScrollView.css";
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { map } from 'lodash';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { createRef } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { MutableRefObject } from 'react';
import { Fade } from '@material-ui/core';

type ScrollViewProps = {
    renderItem: (item: any) => JSX.Element
    keyExtractor: (key: any) => string
    data: Array<any>
    title: string
    style?: any
}

export const ScrollView = (props: ScrollViewProps) => {

    const { data, renderItem, keyExtractor, title} = props


    const ref = useRef<ScrollMenu>()

    useEffect(() => {
        // in reality, we should write some fancy
        // code to check when all images are loaded
        // then run setInitail(), however,
        // this should work for now
        setTimeout(() => {
            !!ref?.current?.setInitial && ref.current.setInitial()
        }, 4000)
    }, [])

    const renderItems = (): JSX.Element[] => {
        if(!data || data.length === 0){
            return map([], (i:any) => <></>)
        }
        return map(data, (item: any) => {
            let i = renderItem(item)
            return <div key={keyExtractor(item)}>{i}</div>
        })
    }

    const items = renderItems()

    return(
        <div className="scrollview"> 
            <Fade in={true} timeout={4000}>
                <h3>{title}</h3>
            </Fade>
            <ScrollMenu 
                ref={ref}
                wheel={false}
                data={items}
                alignOnResize={false}
                arrowRight={<FaChevronRight />}
                arrowLeft={<FaChevronLeft />}
                hideArrows={true}
                alignCenter={false}
                hideSingleArrow={true}
                inertiaScrolling={true}
                arrowClass={"scrollview-arrows"}
                wrapperClass={"scrollview-wrap"}
            />
        </div>
    )

}